module.exports = __webpack_public_path__ + "d5e03e795f5f1948a8b15bf0e7f8cca6.MP3";